import { render, staticRenderFns } from "./Study.vue?vue&type=template&id=b4223086&lang=pug"
import script from "./Study.vue?vue&type=script&lang=ts"
export * from "./Study.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports